import request from "@/utils/request";

export function refreshTokenApi(data) {
  return request({
    url: "/admin/refreshToken",
    method: "post",
    data: data
  });
}

export function login(username, password) {
  return request({
    url: "/admin/login",
    method: "post",
    data: {
      username,
      password
    }
  });
}

export function getInfo() {
  return request({
    url: "/admin/info",
    method: "get"
  });
}

export function logout() {
  return request({
    url: "/admin/logout",
    method: "post"
  });
}

export function fetchList(params) {
  return request({
    url: "/admin/list",
    method: "get",
    params: params
  });
}

// 新增系统管理员基础信息
export function createAdmin(data) {
  return request({
    url: "/admin/insert",
    method: "post",
    data: data
  });
}

export function updateAdmin(data) {
  return request({
    url: "/admin/update",
    method: "post",
    data: data
  });
}

export function updatePasswordApi(data) {
  return request({
    url: "/admin/updatePassword",
    method: "post",
    data: data
  });
}

export function updateStatus(id, params) {
  return request({
    url: "/admin/updateStatus/" + id,
    method: "post",
    params: params
  });
}

export function deleteAdmin(id) {
  return request({
    url: "/admin/delete/" + id,
    method: "post"
  });
}

export function getAdminDetail(data) {
  return request({
    url: "/admin/getCompanyAdmin/" + data.id,
    method: "post"
  });
}

// 新增与修改系统管理员角色
export function insertPermissionApi(id, data) {
  return request({
    url: "/admin/insertPermission/" + id,
    method: "post",
    params: data
  });
}

// 新增与修改管理员店铺
export function insertShopApi(id, data) {
  return request({
    url: "/admin/insertShop/" + id,
    method: "post",
    params: data
  });
}

export function updatePhoneApi(data) {
  return request({
    url: "/admin/updatePhone",
    method: "post",
    data: data
  });
}

export function getVerificationCodeApi(data) {
  return request({
    url: "/admin/getVerificationCode",
    method: "post",
    params: data
  });
}

export function allocRole(data) {
  return request({
    url: "/admin/role/update",
    method: "post",
    data: data
  });
}

export function updatePhotoApi(data) {
  return request({
    url: "/admin/updatePhoto",
    method: "post",
    data: data
  });
}

export function getRandomPasswordApi(data) {
  return request({
    url: "/user/getRandomPassword",
    method: "post",
    data: data
  });
}



// WEBPACK FOOTER //
// ./src/api/login.js